import { MemberContractModel } from "src/api/contract/contract-types";
import VisitorApprovalPendingBadge from "src/components/VisitorApprovalPendingBadge";
import { useVisitorApprovalPendingCount } from "src/hooks/useVisitorApprovalPendingCount";

/**
 * 방문신청 승인 feature(방문자 셀프 등록 또는 방문자 초대 승인) 를 보유한 파트너가
 * 하나라도 있을 때만 표시.
 * 클릭 시 같은 호스트의 space 영역(`/front/space/visitor/selfRegist`)으로 이동한다.
 */
interface MyPageVisitorApprovalProps {
  contracts: MemberContractModel[];
}

const MyPageVisitorApproval = ({ contracts }: MyPageVisitorApprovalProps) => {
  const { hasFeature, pendingCount, isError } = useVisitorApprovalPendingCount(contracts);

  if (!hasFeature) {
    return null;
  }

  return (
    <article className="after-login-visitor-approval">
      <div className="visitor-approval-row icon icon-visitor-approval">
        <a href="/front/space/visitor/selfRegist" className="visitor-approval-link">
          <span className="visitor-approval-label">방문신청 승인</span>
          <VisitorApprovalPendingBadge count={pendingCount} isError={isError} />
        </a>
      </div>
    </article>
  );
};

export default MyPageVisitorApproval;
